module.exports = __webpack_public_path__ + "static/media/long-writes-books.e9b6f735.png";